import NotificationInboxItem from 'shared/components/notifications/notification_inbox_item';
import NotificationStorage from 'shared/components/notifications/notification_storage';
import AhoyEvent from 'shared/ahoy_event';

export default class NotificationInbox {
  constructor(options){
    this.$element = options.$element;
    this.setParentCount = options.setParentCount;
    this.setParentLoaded = options.setParentLoaded;
    this.setParentUnread = options.setParentUnread;
    this.items = [];
  }

  init(){
    this.render();
    this.reRenderWhenStorageUpdated();
    this.bindOnScroll();
  }

  bindOnScroll(){
    this.$element.on("scroll", () => {
      this.triggerImpression();
    });
  }

  reRenderWhenStorageUpdated(){
    NotificationStorage.onChange(this.render.bind(this));
  }

  render(){
    this.items = [];
    var data = NotificationStorage.getFromLocalStorage();
    let unreadCount = data.filter(datum => !datum.read).length;

    this.clearItems();
    this.appendItems(data);
    this.setParentCount(unreadCount);
    this.setParentLoaded(true);
    this.checkNotification();
  }

  checkNotification(){
    var newNotification = NotificationStorage.checkNewNotification();
    this.setParentUnread(newNotification);
    if(newNotification) {
      this.hasSentImpression = false;
    }
  }

  clearItems(){
    this.$element.html("");
  }

  getTopBottom(){
    var bounding = this.$element[0].getBoundingClientRect();
    return {
      top: bounding.top,
      bottom: bounding.bottom
    };
  }

  triggerImpression(){
    this.sendImpressionOnce();
    setTimeout(() => {
      this.triggerImpressionOnItems();
    }, 0);
  }

  sendImpressionOnce(){
    if(this.hasSentImpression){
      return;
    }

    NotificationStorage.setLastReadKey();
    this.setParentUnread(false);

    AhoyEvent.send('VIDIO::SUBSCRIPTION', {
      feature: 'notification',
      action: 'click',
    });
    this.hasSentImpression = true;
  }

  triggerImpressionOnItems(){
    var topBottom = this.getTopBottom();

    for (let index = 0; index < this.items.length; index++) {
      let item = this.items[index];
      item.parentChanged(topBottom.top, topBottom.bottom);
    }
  }

  appendItems(data){
    for (let index = 0; index < data.length; index++) {
      let element = data[index];
      let position = index+1;
      let item = this.renderItem(element, position);
      this.bindClickToItem(item, element.timestamp);
      this.$element.append(item);
    }
  }

  bindClickToItem(item, timestamp) {
    item[0].addEventListener('mousedown', () => {
      NotificationStorage.markAsRead(timestamp);
      return true;
    });
  }

  renderItem(data, index) {
    let item = new NotificationInboxItem({
      read: data.read,
      title: data.title,
      url: data.url,
      body: data.body,
      timestamp: data.timestamp
    }, index);
    this.items.push(item);
    return item.render();
  }
}
